import { useMemo } from "react";
import css from "./leecyber.module.css";

const blocks = [
  {
    title: "Корпоративная почта, которая работает",
    subtitle: "ИИ‑ассистент, общий доступ и задачи — ни одно письмо не потеряется",
    href: "https://leecyber.com/weboffice?utm_source=artcons&utm_medium=partner",
    image: "https://cdn-a.leecyber.com/landing/cweboffice.png",
    alt: "LeeCyber",
  },
  {
    title: "Мониторинг сайта 24/7",
    subtitle: "Показывайте клиентам актуальный статус сервисов и снижайте нагрузку на поддержку",
    href: "https://leecyber.com/status?utm_source=artcons&utm_medium=partner",
    image: "https://cdn-a.leecyber.com/landing/cstatus.png",
    alt: "LeeCyber",
  },
  {
    title: "Кадровый учёт без рутины",
    subtitle: "Автоматизируйте приём, документы, отпуска и учёт сотрудников",
    href: "https://leecyber.com/hrm?utm_source=artcons&utm_medium=partner",
    image: "https://cdn-a.leecyber.com/landing/chrm.png",
    alt: "LeeCyber",
  },
  {
    title: "Электронный документооборот",
    subtitle: "Создание, согласование и подписание документов в одном окне",
    href: "https://leecyber.com/docs?utm_source=artcons&utm_medium=partner",
    image: "/assets/images/hrm_docs.webp",
    alt: "LeeCyber",
  },
  {
    title: "Менеджер паролей для команды",
    subtitle: "Пароли, токены и ключи в одном защищённом и удобном хранилище",
    href: "https://leecyber.com/secrets?utm_source=artcons&utm_medium=partner",
    image: "https://cdn-a.leecyber.com/landing/csecrets.png",
    alt: "LeeCyber",
  },
];

export default function HomeLeeCyber() {
  const block = useMemo(() => {
    const index = Math.floor(Math.random() * blocks.length);
    return blocks[index];
  }, []);

  return (
      <a className={css.leecyber} href={block.href} target="_blank" rel="noreferrer">
        <div className={css.leecyberText}>
          <h3>
            {block.title}
          </h3>
          <p>{block.subtitle}</p>

          <a href={block.href} target="_blank" rel="noreferrer">Узнать подробнее</a>
        </div>
        <div className={css.leecyberImage}>
          <img src={block.image} alt={block.alt} />
        </div>
      </a>
  );
}
